import { ThumbUp, ThumbUpOutlined } from "@mui/icons-material";
import { Button, Link, Stack, SxProps, Tooltip, Typography } from "@mui/material";
import { Links } from "../../constants";
import { useSession } from "../../hooks";
import { IssueDto } from "../../http";

interface IProps {
  issue?: IssueDto;
  isLoading?: boolean;
  onUpvoteClicked: () => void;
  sx?: SxProps;
}

const IssueActions = (props: IProps) => {
  const user = useSession();
  const buttonsDisabled = !props.issue && props.isLoading;

  return (
    <>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={0.5} sx={{ ...props.sx }}>
        <Tooltip
          title={
            props.issue && props.issue.upvotes.length > 0
              ? props.issue.upvotes
                  .sort((a, b) => a.displayName.localeCompare(b.displayName))
                  .map((u, i) => [
                    <Typography key={i} sx={{ display: "inline-block", fontSize: 13, marginRight: "2px" }}>
                      <Link href={Links.User(u.userId)}>{u.displayName}</Link>
                      {i < props.issue!.upvotes.length - 1 && ", "}
                    </Typography>,
                  ])
              : null
          }
        >
          <span>
            <Button
              variant="tertiary"
              startIcon={
                props.issue?.upvotes.findIndex((x) => x.userId === user.userId) !== -1 ? (
                  <ThumbUp />
                ) : (
                  <ThumbUpOutlined />
                )
              }
              disabled={buttonsDisabled}
              onClick={props.onUpvoteClicked}
            >
              {`Upvote (${props.issue?.upvotes.length ?? 0})`}
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </>
  );
};

export { IssueActions };
